import { useMemo } from "react";
import cn from "classnames";
import { RailSearchCardModel } from "entities/RailSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { useTranslation } from "shared/localization/localization";
import { Line } from "./Line";
import styles from "./LineList.module.scss";

type LineListProps = {
  className?: string;
  data: Nullable<RailSearchCardModel>;
};

export const EquipmentsLineList: RFC<LineListProps> = ({ data, className }) => {
  const { t } = useTranslation();
  const equipments = useMemo(() => data?.equipments ?? [], [data?.equipments]);
  const hasEquipments = equipments.length > 0;

  return (
    <div className={cn(styles["line-list"], !hasEquipments && styles["not-available"], className)}>
      {hasEquipments ? (
        equipments.map((equipment, index) => <Line key={index} data={equipment} />)
      ) : (
        <>
          <div className={styles["not-available-bold"]}>
            {t("There is no information about equipment at the moment")}
          </div>
          <div className={styles["not-available-normal"]}>{t("Please, try again later")}.</div>
        </>
      )}
    </div>
  );
};
